import BaseModel from "../../BaseModal"
import styled, { css } from 'styled-components';
import { BaseButton } from '../../styles/ButtonStyles';
import { InputText } from '../../styles/TextStyles';
import React from 'react';
import './Modal.css';

import {
    FlexWrapperCenterForDialog,

} from '../../styles/WrapperStyles';

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-align: center;
  ${props =>
    props.small &&
    css`
      font-size: 16px;
    `}
`;

const RefIdInput = styled(InputText)`
  height: 55px;
  margin-top: 10px;
  margin-bottom: 10px;
`;


const DeleteProfileModal = (props) => {
    const [otpId, setOtpId] = React.useState('');
    const urlType = props.modalText === 'deleteProfile';
    return (
        <BaseModel closeModal={props.closeModal}>
            <FlexWrapperCenterForDialog className="modalTransfer">
                <TextView>{props.modalText}</TextView>
                <RefIdInput
                    placeholder="Enter the OTP"
                    onChange={e => { setOtpId(e.target.value) }}></RefIdInput>
                <BaseButton
                    onClick={() => {
                        if (otpId !== '') {
                            props.handleButtonEvents(urlType, otpId);
                        }
                    }}
                >
                    Submit
                </BaseButton>
            </FlexWrapperCenterForDialog>
        </BaseModel>
    )
}

export default DeleteProfileModal;